jQuery(document).ready(function( $ ) {

	ld_site();
	
	function ld_site() {

		
		/*
		////////////////////////////////////////////////////////////////////////////////////////////////
		// 1 - joints_native
		////////////////////////////////////////////////////////////////////////////////////////////////
		$.joints_native();
		*/
		
		////////////////////////////////////////////////////////////////////////////////////////////////
		// 2 - ld_utilities
		////////////////////////////////////////////////////////////////////////////////////////////////		
		$.ld_utilities( 200 );
		
		////////////////////////////////////////////////////////////////////////////////////////////////
		// 3 - client_scripts_ui
		////////////////////////////////////////////////////////////////////////////////////////////////
		var foundation_large_breakpoint = 1200;
		var foundation_medium_breakpoint = 640;
		$.client_scripts_ui( foundation_large_breakpoint, foundation_medium_breakpoint );
		
		////////////////////////////////////////////////////////////////////////////////////////////////
		// 4 - client_scripts_user_events
		////////////////////////////////////////////////////////////////////////////////////////////////
		$.client_scripts_user_events();
		
		////////////////////////////////////////////////////////////////////////////////////////////////
		// 4 - client_orbit
		////////////////////////////////////////////////////////////////////////////////////////////////		
		$.client_orbit();


		
	}
	
}); 